
export default function (to, from, savedPosition) {
      if (to.name === 'member-privilegeintro' || to.name === 'member-type') {
        return {
          x: 0,
          y: 0
        };
      }
    }
